function path(root: string, sublink: string): string {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

export const PATH_PAGE = {
  page404: '/404'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    send_gift_card: path(ROOTS_DASHBOARD, '/send-gift-card'),
    transaction_history: path(ROOTS_DASHBOARD, '/transaction-history'),
    my_account: path(ROOTS_DASHBOARD, '/my-account')
  }
};
